import Auth from '../../Helpers/auth';
const API_URL = process.env.REACT_APP_BACKEND_URL;

// POST: Creates a Manager or User for a company - protected route
async function httpCreateManagerOrUser(user) {
  const token = Auth.getToken();
  return await fetch(`${API_URL}/companies/auth/create-manager-or-user`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify(user),
  });
}
// POST: Sends the welcome email to the user
async function httpEmployeeSignupEmail(name, email, password, companyId) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/auth/signup-email`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({
      name,
      email,
      password,
      companyId,
    }),
  });
}

// POST: Login manager of the company
async function httpLoginManager(user) {
  return await fetch(`${API_URL}/companies/auth/login`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(user),
  });
}

// POST: Creates forms for the company
async function httpCreateForms(companyId, formData) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/forms/${companyId}`, {
    method: 'post',
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: formData,
  });
}

// POST: Creates a subcontractor for the company
async function httpCreateSubcontractor(companyId, subcontractor) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/subcontractors/${companyId}`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify(subcontractor),
  });
}

// POST: Creates a company
async function httpCreateCompany(company, user) {
  try {
    return await fetch(`${API_URL}/companies/auth/create`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ company, user }),
    });
  } catch (err) {
    return err;
  }
}

// POST: Resend account details to the user
async function httpResendAccountDetails(email, password, userId) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/auth/resend-account-details`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({
      email,
      password,
      userId,
    }),
  });
}

// PUT: Send the template details for the form
async function httpUploadFormInfo(form, formId) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/forms/upload/${formId}`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify(form),
  });
}

// POST: Upload the form with the blank inputs
async function httpUploadForm(formData) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/forms/upload`, {
    method: 'post',
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: formData,
  });
}

// PUT: Edit form info
async function httpEditFormInfo(form) {
  const token = Auth.getToken();
  const { data } = Auth.getProfile() || {};
  form.createdBy = data?.id || null;

  let res = await fetch(`${API_URL}/companies/forms/edit`, {
    method: 'put',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify(form),
  });
  return await res.json();
}

// POST: Add Comments to a form instance
async function httpAddCommentToFormInstance(formInstanceId, comment) {
  const token = Auth.getToken();

  let res = await fetch(`${API_URL}/companies/comments/${formInstanceId}`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({ comment }),
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.msg || 'Failed to add comment');
  }
  return data;
}

// POST: Uploads a company manual
async function httpUploadManual(companyId, manualData) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/manuals/${companyId}`, {
    method: 'post',
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: manualData,
  });
}

// POST: Query the Form
async function httpQueryForm(formId, queryParams) {
  const token = Auth.getToken();

  let res = await fetch(`${API_URL}/companies/forms/query/${formId}`, {
    method: 'post',
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify(queryParams),
  });
  return await res.json();
}

// POST: Assign training to employees from the company subscription
async function httpAssignCompanyTraining(
  companyId,
  selectedCourseIds,
  selectedEmployeeIds,
  userId
) {
  const token = Auth.getToken();

  const body = JSON.stringify({
    courseIds: selectedCourseIds || [],
    employeeIds: selectedEmployeeIds || [],
    userId,
  });

  try {
    const res = await fetch(
      `${API_URL}/companies/training/${companyId}/assign`,
      {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token ? `Bearer ${token}` : '',
        },
        body,
      }
    );

    const text = await res.text();

    if (!text) {
      return {
        success: false,
        message: 'No response received from the server.',
      };
    }

    try {
      return JSON.parse(text);
    } catch {
      return {
        success: false,
        message: 'The server returned an unexpected response.',
        rawResponse: text.slice(0, 300),
      };
    }
  } catch (err) {
    return {
      success: false,
      message: err?.message || 'Unable to assign training.',
    };
  }
}
export {
  httpCreateManagerOrUser,
  httpEmployeeSignupEmail,
  httpLoginManager,
  httpCreateForms,
  httpCreateSubcontractor,
  httpCreateCompany,
  httpResendAccountDetails,
  httpUploadFormInfo,
  httpUploadForm,
  httpEditFormInfo,
  httpAddCommentToFormInstance,
  httpUploadManual,
  httpQueryForm,
  httpAssignCompanyTraining,
};
